module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_shibuya-01e5741966f9f606c010c3b65f556634.jpg";